// TODO: Remove hardcoded shift labels
// Specify role labels to use for particular shifts based on ID:
export const DeprecatedShiftLabels: Record<number, string> = {
    [1711]: "Floater",
    [1715]: "Set Up",
    [1716]: "Set Up",
    [1717]: "Volunteer Check-in Table",
    [1718]: "Event Tabler Check-in",
    [1719]: "Outdoor Stage Assistance",
    [1720]: "Indoor Stage Assistance",
    [1826]: "Registration & Check-In",
    [1827]: "Vendor & Exhibitor Support",
    [1828]: "Keynote & Panel Support",
    [1829]: "Lunch Support",
    [1830]: "Floater",
    [1831]: "Sponsor & VIP Liaison",
    [1832]: "Sponsor & VIP Liaison",
    [1833]: "Social Impact Award Support",
    [1834]: "Social Impact Award Support",
    [1835]: "Floater",
    [1836]: "Closing Keynote Support",
    [1837]: "Room Host for \"Culturally Impactful Engagement with Communities\" - Qiana Holmes",
    [1838]: "Social Impact Happy Hour Support",
    [1839]: "Vendor & Exhibitor Support",
    [1840]: "Setup Support",
    [1841]: "Room Host for \"Differentiating Streams: Fundraising & Development for Nonprofits\" - Amanda White",
    [1842]: "Room Host for \"Compliance & Legal Trends in Nonprofit Management\" - Scholz Nonprofit Law",
    [1843]: "Room Host for \"Executive Directors 101: Developing the Next Generation of Leaders\" - Goodman Foundation Team",
    [1845]: "Room Host for \"Healing the Healers — Embedding Mental Health and Wellbeing in Nonprofit Organizations\" - Shekinah Hockenhull",
}

// Default to using the card list view for shifts for specified opportunities
export const DefaultShiftListViewOppIds = [684, 709, 710];

const eventDateHasPast = (eventDate: Date) => {
    return (eventDate < new Date()) 
}

// Set a particular default date to display on the shift calendar (instead of defaulting to the current date)
export const OpportunityViewDateCalculator: Record<number, () => (Date | undefined)> = {
    [709]: () => {
        const eventDate = new Date(2025, 10, 7);
        if (!eventDateHasPast(eventDate)) {
            return eventDate;
        }
    },
    [710]: () => {
        const eventDate = new Date(2025, 10, 7);
        if (!eventDateHasPast(eventDate)) {
            return eventDate;
        }
    }
}